import sCalendarPanel from '../calendar/calendar-panel'
import sTimePanel from '../time/time-panel'
import { getValidDate, assignTime, pick } from 'toolkit/utils/date'

export default {
  name: 'sDateTimePanel',
  inject: {
    prefixClass: {
      default: 's-datepicker',
    },
  },
  emits: ['select', 'update:show-time-panel'],
  props: {
    ...sCalendarPanel.props,
    ...sTimePanel.props,
    showTimePanel: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      defaultTimeVisible: false,
      currentValue: this.value,
    }
  },
  computed: {
    timeVisible() {
      return typeof this.showTimePanel === 'boolean' ? this.showTimePanel : this.defaultTimeVisible
    },
  },
  watch: {
    value(val) {
      this.currentValue = val
    },
  },
  methods: {
    closeTimePanel() {
      this.defaultTimeVisible = false
      this.$emit('update:show-time-panel', false)
    },
    openTimePanel() {
      this.defaultTimeVisible = true
      this.$emit('update:show-time-panel', true)
    },
    emitDate(date, type) {
      this.$emit('select', date, type)
    },
    handleSelect(date, type) {
      if (type === 'date') {
        this.openTimePanel()
      }
      let datetime = assignTime(date, getValidDate(this.value, this.defaultValue))
      if (this.disabledTime(new Date(datetime))) {
        // set the time of defalutValue;
        datetime = assignTime(date, this.defaultValue)
        if (this.disabledTime(new Date(datetime))) {
          // if disabled don't emit date
          this.currentValue = datetime
          return
        }
      }
      this.emitDate(datetime, type)
    },
  },
  render() {
    const calendarProps = {
      props: {
        ...pick(this.$props, Object.keys(sCalendarPanel.props)),
        type: 'date',
        value: this.currentValue,
      },
      on: {
        select: this.handleSelect,
      },
    }
    const timeProps = {
      props: {
        ...pick(this.$props, Object.keys(sTimePanel.props)),
        showTimeHeader: true,
        value: this.currentValue,
      },
      on: {
        select: this.emitDate,
        clicktitle: this.closeTimePanel,
      },
    }

    const { prefixClass } = this

    return (
      <div>
        <sCalendarPanel {...calendarProps} />
        {this.timeVisible && <sTimePanel class={`${prefixClass}-calendar-time`} {...timeProps} />}
      </div>
    )
  },
}